export default __webpack_public_path__ + "static/media/icon-edit.3c8afef0.svg";